<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import { NutritionalValues } from '@/types/api/api-v3/product'

const props = defineProps({
  nutritionalValue: {
    type: Object as PropType<NutritionalValues>,
    required: true,
  },
  isProductPage: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <div class="product__content-calories">
    <table>
      <tbody>
        <tr :class="{ 'large--font': props.isProductPage }">
          <th>КБЖУ</th>
          <th>{{ `${props.nutritionalValue.protein} г` }}</th>
          <th>{{ `${props.nutritionalValue.fat} г` }}</th>
          <th>{{ `${props.nutritionalValue.carbohydrate} г` }}</th>
          <th>{{ props.nutritionalValue.calorific }}</th>
        </tr>
        <tr :class="{ 'large--font': props.isProductPage }">
          <td>на 100 г</td>
          <td>белки</td>
          <td>жиры</td>
          <td>углеводы</td>
          <td>кКал</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.product__content {
  &-calories {
    @include media('<=tablet') {
      width: 264px;
      margin-top: 0;
    }

    table {
      width: 100%;
      color: $dark-grey;
      text-align: left;
      border-collapse: collapse;

      tr {
        th {
          height: max-content;
          font-size: 12px;
          font-weight: 600;
          line-height: 19px;
        }

        td {
          font-size: 12px;
          font-weight: 600;
          line-height: 19px;
        }
      }

      th:first-child,
      td:first-child {
        border-left: none;
      }

      .large--font {
        td {
          font-size: 16px;
        }
        th {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
